import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectPlatformsScreen = lazy(
  () => import('~/features/item-setup/pages/connect-platforms-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectPlatformsScreen />
    </Suspense>
  ),
});
